export default __webpack_public_path__ + "public/media/arcsite.0cfd144c.png";